export const TAB_SWITCH = "TAB_SWITCH";
export const switchTab = tab => ({
  type: TAB_SWITCH,
  tab
});
